import { render, staticRenderFns } from "./UploadPartCard.vue?vue&type=template&id=065dc0bd&scoped=true&"
import script from "./UploadPartCard.vue?vue&type=script&lang=js&"
export * from "./UploadPartCard.vue?vue&type=script&lang=js&"
import style0 from "./UploadPartCard.vue?vue&type=style&index=0&id=065dc0bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065dc0bd",
  null
  
)

export default component.exports